<template>
  <AllegroJsonForm
    title="Allegro - Dodaj sprzedawcę"
    crumbLabel="Dodaj sprzedawcę"
    :settingsCrumb="true"
    submitAction="createAllegroSeller"
    submitGetter="getAllegroSellerCreateData"
    backRoute="/allegro/accounts"
    accountPkParam="pk"
    :modelPermission="modelPermission"
    :fields="fields"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroSellerPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroSellerCreate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroSellerPermissionsConst.add,
      fields: [
        { key: "tax_id", label: "NIP", required: true },
        { key: "company_name", label: "Nazwa firmy", required: true },
        { key: "first_name", label: "Imię", required: true },
        { key: "last_name", label: "Nazwisko", required: true },
        { key: "street", label: "Ulica", required: true },
        { key: "zip_code", label: "Kod pocztowy", required: true },
        { key: "city", label: "Miejscowość", required: true },
        { key: "logo", label: "Logo", type: "file" },
      ],
    };
  },
};
</script>
